import { FC } from 'react';
import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';

import { TableHead, TableRow, TableWrapper } from '@/components';

import styles from './defaultTable.module.scss';
import { Simplify } from '../../../prismicio-types';

const headComponents: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.headText}>{children}</p>,
};

const rowTitleComponents: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.rowTitle}>{children}</p>,
};

const rowDescriptionComponents: JSXMapSerializer = {
  paragraph: ({ children }) => (
    <p className={styles.rowDescription}>{children}</p>
  ),
};

type Props = {
  data: Simplify<Content.PolicyTableSliceDefaultPrimary>;
};

export const DefaultTable: FC<Props> = ({ data }) => {
  return (
    <TableWrapper>
      <TableHead className={styles.headInner}>
        {data.head.map((item, index) => (
          <PrismicRichText
            key={`${item.title[0]?.type}-${index}`}
            field={item.title}
            components={headComponents}
          />
        ))}
      </TableHead>
      <TableWrapper>
        {data.body.map((item, index) => {
          const hasDescription = 'description' in item;

          return (
            <TableRow
              key={`${item.title[0]?.type}-${index}`}
              className={styles.row}
            >
              <PrismicRichText
                field={item.title}
                components={rowTitleComponents}
              />
              {hasDescription && (
                <div className={styles.description}>
                  <PrismicRichText
                    field={item.description}
                    components={rowDescriptionComponents}
                  />
                </div>
              )}
            </TableRow>
          );
        })}
      </TableWrapper>
    </TableWrapper>
  );
};
